import React from 'react';

const LanguageSwitcher = ({ currentLanguage = 'en', onLanguageChange = () => {} }) => {
  const languages = [
    { code: 'en', label: 'EN' },
    { code: 'gr', label: 'GR' },
    { code: 'es', label: 'ES' },
  ];

  return (
    <div className="flex space-x-2 p-2 rounded-full bg-white shadow-md">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => onLanguageChange(lang.code)}
          className={`px-3 py-1 rounded-full text-sm font-semibold transition-all duration-300 ease-in-out
            ${currentLanguage === lang.code
              ? 'bg-[#FF4C29] text-white shadow-lg'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;